/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { LegalEntityModel } from './legal-entity.model';

export class LegalEntityVo extends JSONable {
  uuid = '';
  uniqueIdentificationNumber = '';
  companyName = '';
  country = '';
  city: string | null = null;
  industryType: string | null = null;

  static mapToDto(legalEntity: LegalEntityVo | null): LegalEntityModel | null {
    if (legalEntity == null) {
      return null;
    }
    const legalEntityModel = new LegalEntityModel();
    legalEntityModel.uuid = legalEntity.uuid;
    legalEntityModel.companyName = legalEntity.companyName;
    legalEntityModel.uniqueIdNumber = legalEntity.uniqueIdentificationNumber;
    legalEntityModel.country = legalEntity.country;

    return legalEntityModel;
  }
}
